export default __webpack_public_path__ + "static/media/diabetes_0.d6fbaaa9.jpg";